/**
 * VF Bingo Balances Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    const virtueFusionService = require('modules/services/vf.service');
    const BingoBonusView = require('replacers/bingo-replacers/bingo-bonus.view');
    const user = require('user');

    module.exports = BingoBonusView.extend({

        getBalance: function() {
            const typeName = {
                'bingobonus': 'Bingo Bonus',
                'gamesbonus': 'Bingo Side Games Bonus',
                'sabingobonus': 'SA Bingo Bonus'
            }[this.options.name];

            virtueFusionService
                .getBalance({
                    balanceType: typeName,
                    correlationId: this.options.name
                })
                .done(this.onSuccess.bind(this))
                .fail(this.onError.bind(this));
        },

        render: function(balance) {
            const currency = user.get('currencyCode');
            let value = balance
                ? window.Playtech.API.formatter.formatCurrency(balance.value, { currencyCode: currency })
                : this.translate('playtech.mobile.system.loyaltyRedeem.info.loading');

            this.$el.html(value);

            return this;
        }

    }, {
        nameOfReplacers: [
            'BINGO_BONUS',
            'GAMES_BONUS',
            'SA_BINGO_BONUS'
        ]
    });
});
